module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C3606"
  }, [_c('strong', [_c('span', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("INTRODUCTION ")]), _vm._v("LAYERS OF ISA-95 TRANSLATION... ")])]), _vm._v(" "), _c('p', {
    staticClass: "C3582"
  }, [_vm._v("Hello All! ")]), _vm._v(" "), _c('p', {
    staticClass: "C4867"
  }, [_vm._v("As the Chair of the ISA-95/MESA Best Practices Working Group (95BPWG), I have had the honor of working with nine white paper committees over the last year and a half to put together the first collection of ISA-95 best practices white papers as Book 1.0. These white paper committees were comprised of members (authors and reviewers) from 23 companies and 11 countries, which shows how ISA-95 is being applied globally. ")]), _vm._v(" "), _c('p', {
    staticClass: "C4867"
  }, [_vm._v("For the newcomer, ISA-95 is a standard called the Enterprise-Control Integration Standard. It is made up of four approved parts with one in draft and one proposed. "), _c('span', {
    attrs: {
      "href": "#/html/07_Chapter#page_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapters 1-3 ")]), _vm._v("contain white papers that provide the ISA-95 overview, comparison to related manufacturing IT standards, and the business case. The newcomer may want to first read either "), _c('span', {
    attrs: {
      "href": "#/html/09_Chapter#page_47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2 ")]), _vm._v("or "), _c('span', {
    attrs: {
      "href": "#/html/11_Chapter#page_89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 ")]), _vm._v("depending on whether they want to start with an overview of the standard or a survey of manufacturing IT standards. ")]), _vm._v(" "), _c('p', {
    staticClass: "C4867"
  }, [_vm._v("The 95BPWG was formed to create a public forum to publish the most current ISA-95 technical and methodology applications while simultaneously evolve a manufacturing application framework (MAF). This is our goal. Within Book 1.0 and each ongoing Book X.0, the current MAF will be updated and defined in White Paper #1. As each collection of white papers is mapped to the MAF, each Book X.0 provides a vehicle for the ISA-95 based MAF and best practices to evolve and be documented efficiently and openly. This provides public methodologies for manufacturing operations management (MOM). End users, vendors, and integrators consider the lack of public MOM methodologies as the major barrier to adoption of the ISA-95 and MOM software space. The white papers also provide a public vehicle to document how the ISA-95 standard is working or needs correction to function better in real-world applications. The 95BPWG is jointly supported by both ISA and MESA International, and is a high priority for each of these organizations to further adoption of ISA-95 and the MOM technology space. ")]), _vm._v(" "), _c('p', {
    staticClass: "C4867"
  }, [_vm._v("Each white paper is mapped to the current MAF in this introduction and in their book chapter order. Additionally, each white paper has been written to stand on its own if read independently and by a reader with a basic understanding of ISA-95. With this said, the content of these white papers DOES require a basic knowledge of ISA-95 and the MOM system domain. Again, White Papers #1-3 "), _c('span', {
    attrs: {
      "href": "#/html/07_Chapter#page_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(Chapters 1-3) ")]), _vm._v("provide the newcomer with the basics to read "), _c('span', {
    attrs: {
      "href": "#/html/13_Chapter#page_119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapters 4-9. ")]), _vm._v("The 95BPWG strongly recommends "), _c('span', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("the ")]), _vm._v("reader study the actual standard prior to any application to derive his or her own perspective on application. One point for the reader to note is each white paper has a slightly different perspective or interpretation of the ISA-95 standard. This is why I consider this work to have many layers of translation as opposed to being a single opinion of production optimization and MOM system architecture. It takes more than a single method to accomplish a single optimization requirement. For instance, White Paper #4, ISA-95 As Is/To Be Study Method, is a very good analysis method but there are a number of IT and business process reengineering assessment methods in IT best practice publications. This is positive and applies to all proposed best practices white papers. Consequently, the reader will notice the white papers are long in length to effectively explain a particular aspect of application. Authors and their papers have no limit on length from the 95BPWG; however, through an extensive peer review process of at least 3 reviewers and 2 editors, the content is required to provide a complete and clear explanation. Prior to paper concept approval, all abstracts are reviewed by the Editorial Advisory Board of the ISA-95/MESA Best Practices Working Group. Papers should support the manufacturing application framework 1.0 (MAF) or propose changes to an updated framework. ")]), _vm._v(" "), _c('p', {
    staticClass: "C4867"
  }, [_vm._v("For Book 1.0, the MAF 1.0 is as follows: ")]), _vm._v(" "), _c('p', {
    staticClass: "C4867"
  }, [_c('span', {
    staticClass: "Underline"
  }, [_vm._v("MAF 1.0 ")])]), _vm._v(" "), _c('p', {
    staticClass: "C4849"
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("Class #1:")]), _vm._v("ISA-95 Technical Applications for Improving B2M Interface Interoperability ")]), _vm._v(" "), _c('p', {
    staticClass: "C4849"
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("Class #2:")]), _vm._v("ISA-95 Transformation Methodology for Improving Operations Interoperability ")]), _vm._v(" "), _c('p', {
    staticClass: "C5666"
  }, [_vm._v("Step 1: Train Staff and Benchmark Technical Applications to Improve B2M Interface Interoperability (Define) ")]), _vm._v(" "), _c('p', {
    staticClass: "C5666"
  }, [_vm._v("Step 2: Structured Mfg. Operations Assessment and Schema Migration Plan (Define, Measure, Analyze) ")]), _vm._v(" "), _c('p', {
    staticClass: "C5666"
  }, [_vm._v("Step 3: Accelerated MOM Implementation and Transformation (Analyze, Improve, Control) ")]), _vm._v(" "), _c('p', {
    staticClass: "C5666"
  }, [_vm._v("Step 4: Life-cycle Management of MOM Application, Interfaces, and Metrics (Analyze, Improve, Control) ")]), _vm._v(" "), _c('p', {
    staticClass: "C4867"
  }, [_vm._v("The reader will notice that MAF 1.0 has been structured around technical (Class #1) and transformation methodology (Class #2) applications where Class #1 applications support Class #2 applications. The Class #2 applications have been organized around the DMAIC Six-Sigma method where the transformation steps are correlated to the DMAIC steps of define, measure, analyze, improve and control, respectively. More explanation on MAF structure is provided in White Paper #1 "), _c('span', {
    attrs: {
      "href": "#/html/07_Chapter#page_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(Chapter 1). ")]), _c('span', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Here ")]), _vm._v("is a preview of what will be included in the ISA-95 Best Practices Book 1.0 ")]), _vm._v(" "), _c('p', {
    staticClass: "C4877"
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("1.")]), _vm._v("ISA-95 Best Practices and Business Case Evolve Through Manufacturing Application ")]), _vm._v(" "), _c('p', {
    staticClass: "C4877"
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("2.")]), _vm._v("An Overview and Comparison of ISA-95 and OAGIS (Standards for Manufacturing Systems Integration: ISA-95 and OAGIS White Paper Series, White Paper #1) ")]), _vm._v(" "), _c('p', {
    staticClass: "C4877"
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("3.")]), _vm._v("Related Manufacturing Integration Standards, A Survey (Standards for Manufacturing Systems Integration: ISA-95 and OAGIS White Paper Series, White Paper #2) ")]), _vm._v(" "), _c('p', {
    staticClass: "C4877"
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("4.")]), _vm._v("ISA-95 As Is/To Be Study Method ")]), _vm._v(" "), _c('p', {
    staticClass: "C4877"
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("5.")]), _vm._v("Manufacturing Information Systems - ISA-88/95 Based Functional Definition ")]), _vm._v(" "), _c('p', {
    staticClass: "C4877"
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("6.")]), _vm._v("Workflow Descriptions Using B2MML ")]), _vm._v(" "), _c('p', {
    staticClass: "C4877"
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("7.")]), _vm._v("ISA-95 Based Operations and KPI Metrics Assessment and Analysis ")]), _vm._v(" "), _c('p', {
    staticClass: "C4877"
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("8.")]), _vm._v("ISA-95: The (SAP) Enterprise-Plant Link to Achieve Adaptive Manufacturing ")]), _vm._v(" "), _c('p', {
    staticClass: "C4877"
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("9.")]), _vm._v("ISA-95 Based Change Management ")]), _vm._v(" "), _c('p', {
    staticClass: "P128"
  }, [_vm._v("The content of white papers in Book 1.0 is best practice and as such are living documents. Please forward all comments to the 95BPWG Chair to the contact information below. ")]), _vm._v(" "), _c('p', {
    staticClass: "C3582"
  }, [_vm._v("All the Best Practice, ")]), _vm._v(" "), _c('p', {
    staticClass: "C4867"
  }, [_vm._v("Charlie Gifford ")]), _vm._v(" "), _c('p', {
    staticClass: "P108"
  }, [_vm._v("ISA-95/MESA Best Practices Working Group Chair ")]), _vm._v(" "), _c('p', {
    staticClass: "P108"
  }, [_vm._v("GE Fanuc Automation ")]), _vm._v(" "), _c('p', {
    staticClass: "P108"
  }, [_c('a', {
    attrs: {
      "href": "mailto:charlie.gifford@ge.com"
    }
  }, [_vm._v("charlie.gifford@ge.com ")])]), _vm._v(" "), _c('p', {
    staticClass: "P108"
  }, [_vm._v("P: (208) 788-5434 ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48244166","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/06_Introduc.vue
// module id = 75
// module chunks = 0